import React, { useState, useContext } from 'react';

import i18next from 'core/i18n';
import { useMutation } from '@apollo/client';
import { Button, Textarea, TinyTitle, palettes, useFlashMessage } from '@indigo-ag/component-module';
import { addAgFinancingTimeLineComment, getAllFinancingEventsForGrower } from '../../queries';
import { FinanceProcessContext } from 'features/brazil-grower/pages/BrazilGrowersDetail';

export const Notes: React.FunctionComponent = () => {
  /**
   * Finance Process Context
   */
  const { agFinancingId } = useContext(FinanceProcessContext);

  /**
   * Mutations
   */
  const [addAgFinancingTimeLineCommentFn] = useMutation(addAgFinancingTimeLineComment);

  const [note, setNote] = useState('');
  const [isSavingNote, setIsSavingNote] = useState(false);

  const handleInputChange = (e: React.ChangeEvent<any>) => {
    setNote(e.target.value);
  };

  const { addFlashMessage } = useFlashMessage();

  const onSubmitNote = (note: string) => {
    setIsSavingNote(true);
    addAgFinancingTimeLineCommentFn({
      refetchQueries: [{ query: getAllFinancingEventsForGrower, variables: { agFinancingId } }],
      variables: {
        agFinancingId,
        comment: note
      }
    }).then(() => {
      addFlashMessage({
        content: i18next.t('noteMessageResponse'),
        title: '',
        variant: 'success'
      });
      setIsSavingNote(false);
    });
  };

  const handleSubmit = () => {
    onSubmitNote(note);
    setNote('');
  };

  return (
    <div style={{ paddingLeft: 10, paddingTop: 40, display: 'column' }}>
      <TinyTitle style={{ color: palettes.neutral[700] }}>{i18next.t('notes')}</TinyTitle>
      <Textarea label="" rows={4} maxLength={280} value={note} onChange={handleInputChange} />
      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Button busy={isSavingNote} onClick={handleSubmit} variant="secondary" disabled={note === ''} size="small">
          {i18next.t('post')}
        </Button>
      </div>
    </div>
  );
};
